//我的授权
<template>
  <div id="myAuth">
    <!-- 搜索框 -->
    <div class="search_aera">
      <span class="item" v-if="getEscSearchIcon" @click="escSearch()">退出搜索</span>
      <el-input
        placeholder="请输入搜索内容"
        size="mini"
        v-model="dest"
        @keyup.enter="getOrdersListAction({ options })"
      >
        <el-button
          slot="append"
          size="mini"
          type="primary"
          icon="el-icon-search"
          :disabled="dest.trim() == ''"
          @click="getOrdersListAction({ options })"
          title="搜索"
        ></el-button>
      </el-input>
    </div>
    <!-- 表格 -->
    <el-table :data="showList" border ref="auth" @sort-change="emitSort">
      <el-table-column
        prop="order_number"
        label="最终客户采购合同/订单编号"
        width="130px"
        align="center"
        sortable="custom"
      ></el-table-column>
      <!-- <el-table-column prop="update_time" label="订单时间" align="center" sortable="custom"></el-table-column> -->
      <el-table-column prop="contact" label="联系人" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="authbatch__product_name" label="产品名称" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="authbatch__product_ver" align="center" sortable="custom" label="产品版本"></el-table-column>
      <el-table-column prop="authbatch__auth_type" align="center" sortable="custom" label="授权类型"></el-table-column>
      <el-table-column prop="authbatch__auth_num" align="center" label="授权数量"></el-table-column>
      <el-table-column prop="authbatch__auth_date" align="center" sortable="custom" label="授权日期"></el-table-column>
      <el-table-column label="镜像下载" align="center">
        <template slot-scope="scope">
          <a v-if="scope.row.authbatch__link" :href="scope.row.authbatch__link">
            <img src="/static/img/file_download.png" alt="下载" />
          </a>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="升级镜像" align="center">
        <template slot-scope="scope">
          <a v-if="scope.row.authbatch__update_link" :href="scope.row.authbatch__update_link">
            <img src="/static/img/file_download.png" alt="下载" />
          </a>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            :disabled="!(scope.row.owner.includes(userName) && scope.row.authbatch__id)"
            size="mini"
            @click="showDetails(scope.row.authbatch__id)"
          >详情</el-button>
          <!-- <el-button
            :disabled="!(scope.row.owner.includes(userName) && scope.row.authbatch__id)"
            :type="scope.row.owner.includes(userName) && scope.row.authbatch__id ? 'primary' : 'info'"
            size="mini"
            @click="showDetails(scope.row.authbatch__id)"
          >详情</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="allList"
      :background="true"
      layout="total, prev, pager, next, jumper"
      prev-text="上一页"
      next-text="下一页"
      @current-change="currentPageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "pcib-order-my-auth",
  data() {
    return {
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页面
      parmas: {}, // 排序信息
      dest: "" // 搜索关键词
    };
  },
  computed: {
    userName() {
      return JSON.parse(sessionStorage.getItem("user")).username;
    },
    // 展示列表
    showList() {
      console.log('in showList allList=' + this.allList)
      let arr = [];
      let isEmptyObj = obj => {
        for (let key in obj) {
          return false;
        }
        return true;
      };
      this.getOrdersList.forEach(item => {
        let obj = {};
        obj.order_number = item.order_number;
        obj.update_time = item.update_time;
        obj.contact = item.contact;
        obj.owner = item.owner;
        if (item.auth_batch && !isEmptyObj(item.auth_batch)) {
          Object.keys(item.auth_batch).forEach(val => {
            obj["authbatch__" + val] = item.auth_batch[val];
          });
        }
        arr.push(obj);
      });
      return arr;
    },
    // 数据总数
    allList() {
      // return this.getOrdersList.length;
      return this.getTotalOrderCount;
    },
    // 接口参数
    options() {
      let sort = this.parmas.order
        ? this.parmas.order === "ascending"
          ? this.parmas.prop
          : "-" + this.parmas.prop
        : "";
      return {
        limit: 10,
        offset: (this.currentPage - 1) * 10,
        sort: sort,
        dest: this.dest
      };
    },
    ...mapGetters("config", {
      getOrdersList: "getOrdersList",
      getTotalOrderCount: "getTotalOrderCount",
      getEscSearchIcon: "getEscSearchIcon"
    })
  },
  methods: {
    // 点击分页
    currentPageChange(index) {
      this.currentPage = index;
      this.getOrdersListAction({ options: this.options });
    },
    // 点击表头排序
    emitSort(args) {
      this.parmas = args;
      this.getOrdersListAction({ options: this.options });
    },
    // 跳转到订单详情
    showDetails(id) {
      this.$router.push({
        name: "pcibOrderSerialDetails",
        params: {
          order_id: id
        }
      });
    },
    // 退出搜索
    escSearch() {
      this.dest = "";
      this.getOrdersListAction({ options: this.options });
    },
    ...mapActions("config", {
      getOrdersListAction: "getOrdersListAction2"
    })
  },
  mounted() {
    this.getOrdersListAction({ options: this.options });
  }
};
</script>

<!-- 组件的样式不复用 -->
<style scoped lang="scss">
@import "~@/style/base/constant";
@import "~@/style/components/my_auth";
</style>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderMyAuth.vue